import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import CustomButton from '../Button';
import styles from './DeleteModal.module.scss';

interface DeleteModalProps {
  visible: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  loading: boolean;
  selectedItems?: Set<number>;
  selectedItemsDetails?: Array<{ id: number; name: string; entryType: string; status?: string; share?: any[]; thumbnail?: any }>;
  fileDetail?: any;
  currentEntry?: any;
  variant?: 'internal' | 'external';
  /** Varsa başlık olarak bu kullanılır; öğe listesi gösterilmez (örn. yorum silme) */
  titleOverride?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  loading,
  selectedItems,
  selectedItemsDetails,
  fileDetail,
  currentEntry,
  variant = 'internal',
  titleOverride,
}) => {
  const getModalTitle = () => {
    if (selectedItems && selectedItems.size > 0) {
      // Seçili öğelerin entryType'ı aynı varsayılıyor
      let typeLabel = 'Item';
      if (selectedItemsDetails && selectedItemsDetails.length > 0) {
        const entryType = (selectedItemsDetails[0].entryType || '').toString();
        if (entryType === 'File') typeLabel = 'File';
        else if (entryType === 'Folder') typeLabel = 'Folder';
        else if (entryType === 'Project') typeLabel = 'Project';
        else if (entryType === 'Version') typeLabel = 'Version';
        else typeLabel = entryType || 'Item';
      }
      const plural = selectedItems.size > 1 ? 's' : '';
      return `Delete  ${typeLabel}${plural}`;
    }
    if (fileDetail) {
      return window.location.hash ? "Delete Version" : "Delete File";
    }
    if (currentEntry) {
      return `Delete ${currentEntry.name} ${currentEntry.entryType === 'File' ? 'File' : 'Folder'}`;
    }
    return "Delete";
  };

  const getItemNames = (): string[] => {
    if (selectedItems && selectedItems.size > 0 && selectedItemsDetails && selectedItemsDetails.length > 0) {
      return selectedItemsDetails.map((item) => item.name);
    }
    if (fileDetail) {
      return [fileDetail.name];
    }
    if (currentEntry) {
      return [currentEntry.name];
    }
    return [];
  };

  const modalTitle = titleOverride ?? getModalTitle();
  const itemNames = titleOverride ? [] : getItemNames();

  return (
    <Modal
      centered
      title={
        <div className={styles.modalHeader}>
          <span className={styles.modalTitle}>{modalTitle}</span>
          <CloseOutlined
            onClick={onCancel}
            className={styles.closeIcon}
          />
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      className={`${styles.deleteModal} ${variant === 'external' ? styles.deleteModalExternal : ''}`}
      width={600}
    >
      <div className={styles.modalContent}>
        <div className={styles.content}>
          <p className={styles.mainText}>
            Are you sure you want to delete? This action cannot be undone.
          </p>
          {itemNames.length > 1 && (
            <ul className={styles.itemList}>
              {itemNames.map((name, index) => (
                <li key={index} className={styles.listItem}>
                  {name}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className={styles.actionButtons}>
          <CustomButton
            onClick={onCancel}
            className={styles.cancelButton}
          >
            Cancel
          </CustomButton>
          <CustomButton
            onClick={() => onConfirm()}
            loading={loading}
            className={styles.deleteButton}
          >
            Delete
          </CustomButton>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal; 